import { useState, useRef } from 'react';
import { contactType, inquiryType } from '@Components/Utilities/SandhillsConstants';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import ComplexBreadcrumb from '@Components/Shared/ComplexBreadcrumb';
import DealerHeaderInfo from '@Components/Shared/DealerHeaderInfo';

const EmailModal = loadable(() => import('@Components/Shared/Modals/EmailModal'), true);

const FBODetailsView = (props) => {

    const [samModel, setSamModel] = useState(props.FBODealerHeader.SAMModel);
    const [selectedInquiry, setSelectedInquiry] = useState(inquiryType.Email);
    const [selectedContactType, setSelectedContactType] = useState(contactType.Retail);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const onEmailModalToggle = () => {
        setShowEmailModal(showEmailModal => !showEmailModal);
        if (returnFocusRef.current[inquiryType.Email] && showEmailModal) {
            returnFocusRef.current[inquiryType.Email].focus();
        }
    }
    const returnFocusRef = useRef([]);

    const openEmailModal = (inquiry, contact, modalData) => {
        inquiry = inquiry || inquiryType.Email;
        contact = contact || contactType.Retail;
        modalData = modalData || {};
        setSelectedInquiry(inquiry);
        setSelectedContactType(contact);
        setShowEmailModal(showEmailModal => !showEmailModal);
        setSamModel({ ...samModel, ...modalData });
    };

    return (
        <div className='list-content'>
            <ComplexBreadcrumb BreadCrumbModels={props.BreadCrumbs} />
            <DealerHeaderInfo
                {...props.FBODealerHeader}
                openEmailModal={openEmailModal}
                ref={returnFocusRef}
            />
            {showEmailModal &&
                <EmailModal
                    {...samModel}
                    toggleEmailModal={onEmailModalToggle}
                    selectedInquiry={selectedInquiry}
                    selectedContactType={selectedContactType}
                    DefaultCultureCode={props.DefaultCultureCode}
                    IsFBO={true}
                    ref={returnFocusRef}
                />}
        </div>
    );
};

export default FBODetailsView;
global.FBODetailsView = FBODetailsView;